import { useTranslation } from 'react-i18next';
import ButtonSecondaryMedium from '../../common/ButtonSecondary/ButtonSecondaryMedium';
import { Icon } from '../../icon/icon';
import './CustomProductCard.scss';

const CustomProductCard = ({ onClick, img, label }) => {
  const { t } = useTranslation();
  return (
    <div className="custom-product-card" onClick={onClick}>
      <img src={img} alt="Cột nhà" />
      <span className="text-label-medium">{label}</span>
      <ButtonSecondaryMedium
        posIcon={<Icon.ICAdd />}
        title={<span className={'text-body-small-emphasized'}>{t('Add')}</span>}
        className={'btn'}
        type={'button'}
      />
    </div>
  );
};

export default CustomProductCard;
